import { Tabs, Tab, Box } from '@mui/material';
import { useCompanySelection } from '../../hooks/useCompanySelection';

const CompanyTabs = () => {
  const {
    companies,
    selectedIco,
    selectCompany,
    hasMultipleCompanies,
  } = useCompanySelection();

  // Don't show tabs if there's only one company
  if (!hasMultipleCompanies) {
    return null;
  }

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    selectCompany(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs
        value={selectedIco || companies[0]?.ico || ''}
        onChange={handleChange}
        aria-label="Výběr společnosti"
        variant="scrollable"
        scrollButtons="auto"
      >
        {companies.map((company) => (
          <Tab
            key={company.ico}
            label={company.companyName}
            value={company.ico}
            sx={{
              textTransform: 'none',
              fontWeight: selectedIco === company.ico ? 600 : 400,
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default CompanyTabs;

